import { Expose, Type } from 'class-transformer'

import { Tag } from './Tag'

export class Attachment {
  static type = 'attachment'

  type = Attachment.type

  @Expose({ name: 'xid' })
  guid?: string

  file?: string

  @Type(() => Tag)
  tags?: Tag[]
}
